import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { WORK } from '../mock';

export default function Work() {
  return (
    <section id="work" className="py-24 md:py-32 border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="eyebrow mono-font text-black/60">Selected Work</div>
        <h2 className="display-font mt-8 text-[10vw] md:text-[4.6rem] leading-[0.95] max-w-4xl">
          Products we built <span className="accent-red">with embedded teams.</span>
        </h2>

        <div className="mt-16 divide-y divide-black/10">
          {WORK.map((w, i) => (
            <div key={w.title} className="card-hover py-10 grid lg:grid-cols-12 gap-8 items-center group cursor-pointer">
              <div className={`lg:col-span-6 ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="overflow-hidden rounded-xl border border-black/10">
                  <img src={w.image} alt={w.title} className="work-img w-full h-72 md:h-80 object-cover" />
                </div>
              </div>
              <div className={`lg:col-span-6 lg:pl-8 ${i % 2 === 1 ? 'lg:order-1 lg:pl-0 lg:pr-8' : ''}`}>
                <div className="mono-font accent-red">{w.tag}</div>
                <h3 className="display-font mt-4 text-3xl md:text-5xl text-black flex items-start gap-3">
                  <span>{w.title}</span>
                  <ArrowUpRight className="w-8 h-8 mt-2 text-black/70 group-hover:text-[#FF5C4D] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </h3>
                <p className="mt-4 text-black/60 max-w-lg">{w.body}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {w.tags.map((t) => (
                    <span key={t} className="mono-font border border-black/15 px-3 py-1 rounded text-black/70">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
